import { render } from "./modalLoad.vue?vue&type=template&id=0f08aa28&scoped=true"
import script from "./modalLoad.vue?vue&type=script&lang=js"
export * from "./modalLoad.vue?vue&type=script&lang=js"

import "./modalLoad.vue?vue&type=style&index=0&id=0f08aa28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f08aa28"]])

export default __exports__